<script setup lang="ts">
import { computed } from 'vue';
import { type Shift } from '@/api/shifts';
import { usePermissions } from '@/composables/usePermissions';
import AttendanceEditForm from './attendance-edit-form.vue';

const props = defineProps<{
  shift: Shift;
}>();

const emit = defineEmits(['close', 'refetch', 'success']);

const { hasPermission } = usePermissions();

const canShowCheckIn = computed(() => props.shift.canEditCheckIn && !!props.shift.checkIn);
const canShowCheckOut = computed(() => props.shift.canEditCheckOut && !!props.shift.checkOut);
</script>

<template>
  <v-card
    v-if="hasPermission('attendances', 'update')"
    class="pa-4"
  >
    <v-card-title class="mt-2 d-flex justify-space-between">
      Editar Asistencias
    </v-card-title>
    <v-card-text>
      <v-row>
        <attendance-edit-form
          v-if="props.shift.checkIn"
          :attendance="props.shift.checkIn"
          attendance-type="checkIn"
          :can-edit="canShowCheckIn"
          @success="emit('success')"
          @refetch="emit('refetch')"
        />
        <attendance-edit-form
          v-if="props.shift.checkOut"
          :attendance="props.shift.checkOut"
          attendance-type="checkOut"
          :can-edit="canShowCheckOut"
          @success="emit('success')"
          @refetch="emit('refetch')"
        />
      </v-row>
      <v-alert
        v-if="!canShowCheckIn && !canShowCheckOut"
        type="info"
        variant="tonal"
        class="mt-4"
      >
        No hay asistencias disponibles para editar en este turno.
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        text="Volver"
        @click="emit('close')"
      />
    </v-card-actions>
  </v-card>
</template>
